import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from 'react-router-dom';
const TableTopLandingPage = lazy(() => import('./tableTopLandingPage'));


const TableTop = (props) => {
  return (
    <Router>
            <Suspense fallback={<Loader />}>
      {/* <Route exact path={`${props.match.url}/`} component={TableSelection} /> */}
      <Routes>
        <Route exact path={`${props.match.url}/`} element={<TableTopLandingPage/>} />
        </Routes>
        </Suspense>
    </Router>
  );
};

export default TableTop;
